import React from "react";
import JoditEditor from "jodit-react";

const RichTextEditor = () => {
    return <JoditEditor/>;
}
export default RichTextEditor;